"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bluekeelAssets = _interopRequireDefault(require("@bit/bluekeel.assets.usc-flag-right"));

var _bluekeelAssets2 = _interopRequireDefault(require("@bit/bluekeel.assets.usc-flag-left"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100vw',
    WebkitBoxShadow: 'inset 0px -4px 6px -6px rgba(0,0,0,1)',
    MozBoxShadow: 'inset 0px -4px 6px -6px rgba(0,0,0,1)',
    boxShadow: 'inset 0px -4px 6px -6px rgba(0,0,0,1)'
  },
  usc: {
    backgroundImage: "url(".concat(_bluekeelAssets2.default, "), url(").concat(_bluekeelAssets.default, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundSize: '220px auto',
    backgroundPosition: 'left top, right top',
    minHeight: 'inherit',
    '@media (max-width: 767px)': {
      backgroundSize: '60px auto',
      padding: '0 0 30px 0'
    }
  },
  pcm: {
    backgroundColor: 'rgb(216,226,240)'
  },
  wiki: {
    backgroundColor: 'aliceblue'
  },
  wikiStart: {
    backgroundColor: '#ffffff',
    minHeight: '300px',
    '@media (max-width: 767px)': {
      minHeight: '35vh !important'
    }
  },
  pcmStart: {
    backgroundColor: '#ffffff',
    minHeight: '40vh'
  },
  uscStart: {
    backgroundImage: "url(".concat(_bluekeelAssets2.default, "), url(").concat(_bluekeelAssets.default, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundSize: '220px auto',
    backgroundPosition: 'left top, right top',
    minHeight: '300px',
    '@media (max-width: 767px)': {
      backgroundSize: '60px auto',
      padding: '0 0 30px 0'
    }
  },
  questionBox: {
    maxWidth: '1000px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      maxWidth: '100vw',
      minWidth: '100vw',
      padding: '0'
    }
  }
}; // import UscFlagRight from '@bit/bluekeel.assets.usc-flag-right';
// import UscFlagLeft from '@bit/bluekeel.assets.usc-flag-left';
// export default {
//     wrapper: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'center',
//         width: '100vw',
//         WebkitBoxShadow: 'inset 0px -4px 6px -6px rgba(0,0,0,1)',
//         MozBoxShadow: 'inset 0px -4px 6px -6px rgba(0,0,0,1)',
//         boxShadow: 'inset 0px -4px 6px -6px rgba(0,0,0,1)',
//     },
//     uscDesktop: {
//         backgroundImage: `url(${UscFlagLeft}), url(${UscFlagRight})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundSize: '220px auto',
//         backgroundPosition: 'left top, right top',
//         minHeight: 'inherit',
//     },
//     uscMobile: {
//         backgroundImage: `url(${UscFlagLeft}), url(${UscFlagRight})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundSize: '60px auto',
//         backgroundPosition: 'left top, right top',
//         padding: '0 0 30px 0',
//     },
//     pcmDesktop: {
//         backgroundColor: 'rgb(216,226,240)',
//     },
//     pcmMobile: {
//         backgroundColor: 'rgb(216,226,240)',
//     },
//     wikiDesktop: {
//         backgroundColor: 'aliceblue',
//     },
//     wikiMobile: {
//         backgroundColor: 'aliceblue',
//     },
//     wikiStartDesktop: {
//         backgroundColor: '#ffffff',
//         minHeight: '300px',
//     },
//     wikiStartMobile: {
//         backgroundColor: '#ffffff',
//         minHeight: '30vh'
//     },
//     startDesktop: {
//         backgroundColor: '#ffffff',
//         minHeight: '40vh'
//     },
//     startMobile: {
//         backgroundColor: '#ffffff',
//         minHeight: '40vh'
//     },
//     uscStartDesktop: {
//         backgroundImage: `url(${UscFlagLeft}), url(${UscFlagRight})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundSize: '220px auto',
//         backgroundPosition: 'left top, right top',
//         minHeight: '50vh'
//     },
//     uscStartMobile: {
//         backgroundImage: `url(${UscFlagLeft}), url(${UscFlagRight})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundSize: '60px auto',
//         backgroundPosition: 'left top, right top',
//         padding: '0 0 30px 0',
//         minHeight: '50vh'
//     },
//     questionBox: {
//         maxWidth: '1000px',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         '@media (max-width: 767px)': {
//             maxWidth: '100vw',
//             minWidth: '100vw',
//             padding: '0'
//         }
//     }
// }

exports.default = _default;

//# sourceMappingURL=FlowWrapper.css.js.map